import { formatBenefitMoney } from "./pse-match-display"
import { pseEnergyTypeLabels } from "./benefit-enums"

/** Only the already-authorized prior-file projection. Never used in designation/save payloads. */
export interface PriorHouseholdComparison {
  addresses?: Record<string, { address?: string; city?: string; state?: string; zipCode?: string }>
  monthlyAdjustedIncome?: unknown
  age0to2?: number
  age3to5?: number
  age6to17?: number
  age18to59?: number
  age60Plus?: number
  disabled?: number
  benefitEligibility?: Array<{
    benefitProgramInstance: { program: number; year: number; revision: number }
    isEligible: boolean
    eligibleAmount: unknown
  }>
}

export function priorMailingAddress(benefit: PriorHouseholdComparison | null): string {
  const address = benefit?.addresses?.Mailing ?? benefit?.addresses?.["2"]
  const parts = address && [address.address, address.city, address.state, address.zipCode]
    .filter((part): part is string => typeof part === "string" && part.trim().length > 0)
  return parts?.length ? parts.join(", ") : "Not available"
}

/** The API's canonical enum converter writes a display string; older fixtures may use its byte. */
export function priorPseEnergyType(value: unknown): string {
  if (typeof value === "number") return pseEnergyTypeLabels[value] ?? "Not available"
  if (typeof value === "string" && Object.values(pseEnergyTypeLabels).includes(value)) return value
  return "Not available"
}

export function priorHouseholdCount(value: number | undefined): string {
  return typeof value === "number" && Number.isInteger(value) && value >= 0 ? String(value) : "Not available"
}

/** HELP eligibility is not the root's combined multi-program AmountEligible total. */
export function priorHelpEligibility(benefit: PriorHouseholdComparison | null, programYear: number | undefined): {
  eligibility: string
  amount: string
} {
  const matches = benefit?.benefitEligibility?.filter(item =>
    item.benefitProgramInstance?.program === 0 && item.benefitProgramInstance.year === programYear) ?? []
  // Multiple determinations/revisions are ambiguous reference evidence; do not pick an arbitrary one.
  if (matches.length !== 1) return { eligibility: "Not available", amount: "Not available" }
  const match = matches[0]!
  return {
    eligibility: typeof match.isEligible === "boolean" ? (match.isEligible ? "Yes" : "No") : "Not available",
    amount: formatBenefitMoney(match.eligibleAmount),
  }
}
